import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.number.constructor.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
import Store from "../store";
var Transaction = /*#__PURE__*/function (_BaseModel) {
  function Transaction(params) {
    var _this;
    _classCallCheck(this, Transaction);
    _this = _callSuper(this, Transaction, [params]);
    _this._store = Store();
    _this._types = {
      1: 'Regular Repayment',
      2: 'Scheduled Repayment Charge',
      3: 'Direct Charge',
      4: 'Pre Payment Verification',
      5: 'Card Registration',
      6: 'Application Declined',
      7: 'Transaction Reversal',
      8: 'Chargeback',
      9: 'Direct Bank Deposit',
      10: 'Refund',
      11: 'Over Payment',
      12: 'Credit'
    };
    return _this;
  }
  _inherits(Transaction, _BaseModel);
  return _createClass(Transaction, [{
    key: "type",
    value: function type() {
      return this._types[this.get('transaction_type_id')];
    }
  }, {
    key: "card",
    value: function card() {
      var _this2 = this;
      return this._store.state.cards.cards.find(function (card) {
        return card.id() === Number(_this2.get('card_id'));
      });
    }
  }]);
}(BaseModel);
export default Transaction;